/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 */

import { targetGateway, travelQuotesCreateQuote } from '../../constants/apiRequest/requestConstants/endpoints';
import { sendAnalyticsEvent } from '../../helpers';
import { makeRequest } from '../../helpers/makeApiRequest';


export const postTravelQuote = async (travelQuoteData, props = {}) => {
  const quoteRequest = await makeRequest({
    method: 'POST',
    url: `${targetGateway()}${travelQuotesCreateQuote}`,
    payload: travelQuoteData,
    history: props.history
  });
  sendAnalyticsEvent(quoteRequest, 'insuranceEvent', 'Travel');
  return quoteRequest;
};
